import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  padding: 30px 0 5px;
  box-shadow: inset 2000px 0 0 0 rgba(255, 255, 255, 0.9);
  text-align: center;

  h2 {
    ${props => props.theme.css.heading3};
    color: ${props => props.theme.palette.primary.alphaDark};
    text-transform: uppercase;
  }

  p {
    padding: 10px 60px;
  }

  .categories {
    display: flex;
    justify-content: space-around;
    margin: 30px auto 0;
    background: ${props => props.theme.palette.primary.alpha};
    color: ${props => props.theme.palette.general.light};
    padding: 30px 30px 50px;
    ${bp('sm')`
      flex-wrap: wrap;
    `}

    p {
      font: ${font('default', 'bold', '24px/1.2')};
      color: ${props => props.theme.palette.general.soft};
      ${bp('lg')`
        font: ${font('default', 'bold', '20px/1.2')};
      `}
    }

    a {
      display: block;
      text-decoration: none;
      max-width: 320px;
      margin: auto;
      cursor: pointer;
    }

    .button {
      padding: 20px 40px;
      max-width: 320px;
      border-radius: 10px;
      background: ${props => props.theme.palette.primary.alphaDark};
      margin: auto;
      box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.75);
      font: ${font('default', 'bold', '18px/1.5')};
      color: ${props => props.theme.palette.general.light};
      ${bp('lg')`
        max-width: 150px;
        padding: 10px 20px;
      `}
    }
  }
`
